import ButtonNavigatorComponent from "../../../../../components/ButtonNavigator";
import IconButton from "../../../../../components/IconButton";
import Spinner from "../../../../../components/Spinner";
import { IconSwitch } from "../../../../../icons";
import { THEADERMOCK } from "../constants";
import useStoreGridCollaborator from "../store/useStore";
import TBodyCollaborator from "./TBodyComponets";

export default function TableGridCollaborator() {
  const {
    handleOrderList,
    emptyFilter,
    needSpinner,
    inactiveOrActive,
    collaboratorsDeleted,
    collaboratorActivated,
    page,
    selectSize,
    setSelectSize,
    setPage,
  } = useStoreGridCollaborator();
  // className="phone-collaborator"
  return (
    <div className="collaboratorTableContainer table-container-full box-shadow">
      <Spinner classNameFather="spinnerTable" status={needSpinner}>
        <table className="collaboratorTable">
          {emptyFilter === false ? (
            <>
              <thead>
                <tr>
                  {THEADERMOCK?.map((header) => {
                    if (header?.value === "end_date" && !inactiveOrActive) return;
                    return (
                      <th
                        className={`header-center
                          ${header?.value === "phone" && "phone-collaborator"} 
                          ${header?.value === "isBilled" && "phone-collaborator"} 
                          ${header?.value === "beginnig_at" && "beginnigAt-collaborator"}
                          ${header?.value === "CPF" && "cpf-collaborator"}
                        `}
                      >
                        <div className="wrapperTheader">
                          <span>{header.name}</span>
                          <IconButton icon={IconSwitch} onClick={() => handleOrderList(header.value)} />
                        </div>
                      </th>
                    );
                  })}
                  <th className="header-center">Ver Mais</th>
                </tr>
              </thead>
              <tbody>
                <TBodyCollaborator />
              </tbody>
            </>
          ) : (
            <div className="nothing-list">
              <h1>Não há registros para a busca realizada.</h1>
            </div>
          )}
        </table>

        <ButtonNavigatorComponent
          className="ButtonNavigatorCollaborator"
          page={page}
          setPage={setPage}
          selectSize={selectSize}
          setSelectSize={setSelectSize}
          list={inactiveOrActive ? collaboratorsDeleted : collaboratorActivated}
        />
      </Spinner>
    </div>
  );
}
